var _path, _mask;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.67.627l16 8a6 6 0 013.33 5.37V33.06a5.998 5.998 0 01-3.325 5.368l-16 8a6 6 0 01-5.37 0L5.3 38.424A5.995 5.995 0 012 33.038V13.997a5.998 5.998 0 013.326-5.368l7.612-3.806c.108-.068.222-.125.34-.17L21.33.626a6 6 0 015.34 0zM14.01 8.759l-5.528 2.764L24 19.282l5.528-2.764-15.518-7.76zM34 14.282l-15.518-7.76 4.633-2.315a1.998 1.998 0 011.773.001l14.63 7.315L34 14.282zm.876 4.034l.04-.02L42 14.754v18.304a2 2 0 01-1.11 1.789L26 42.292V22.754l8.876-4.438zM6 14.754l16 8v19.548L7.095 34.849A1.998 1.998 0 016 33.052V14.754z",
    fill: "#777E8C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "package_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 45,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.67.627l16 8a6 6 0 013.33 5.37V33.06a5.998 5.998 0 01-3.325 5.368l-16 8a6 6 0 01-5.37 0L5.3 38.424A5.995 5.995 0 012 33.038V13.997a5.998 5.998 0 013.326-5.368l7.612-3.806c.108-.068.222-.125.34-.17L21.33.626a6 6 0 015.34 0zM14.01 8.759l-5.528 2.764L24 19.282l5.528-2.764-15.518-7.76zM34 14.282l-15.518-7.76 4.633-2.315a1.998 1.998 0 011.773.001l14.63 7.315L34 14.282zm.876 4.034l.04-.02L42 14.754v18.304a2 2 0 01-1.11 1.789L26 42.292V22.754l8.876-4.438zM6 14.754l16 8v19.548L7.095 34.849A1.998 1.998 0 016 33.052V14.754z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "8906be289cd9c8248c4ee44134e5b1dc.svg";
export { SvgPackage as ReactComponent };